<script setup lang="ts">
import { nextTick, ref } from "vue";
import ScaleMenuState from "@/stores/ScaleMenuState";
import type { ScaleConfig } from "@/types/legend.types";
import ScaleListItem from "./ScaleListItem.vue";
import ScaleForceSize from "./ScaleForceSize.vue";

/**
 * Contenu du bouton Échelle de l'en-tête : la liste des échelles directement
 * (défilante au-delà d'une hauteur max) et, toujours visible en pied, la
 * hauteur de texte forcée.
 */
const emit = defineEmits<{ (e: "selected"): void }>();

const listRef = ref<HTMLElement | null>(null);

function onSelect(scale: ScaleConfig) {
  if (ScaleMenuState.activeScale?.name !== scale.name) {
    ScaleMenuState.selectScale(scale);
  }
  emit("selected");
}

/** À l'ouverture, amène l'échelle active dans la zone visible de la liste. */
function revealActive() {
  nextTick(() => {
    listRef.value
      ?.querySelector<HTMLElement>(".scale-list-item.active")
      ?.scrollIntoView({ block: "nearest" });
  });
}

defineExpose({ revealActive });
</script>

<template>
  <div class="scale-list d-flex flex-column">
    <div ref="listRef" class="scale-list-items p-1">
      <ScaleListItem
        v-for="scale in ScaleMenuState.scales"
        :key="scale.name"
        :scale="scale"
        @select="onSelect"
      />
    </div>
    <div class="scale-list-footer p-2">
      <ScaleForceSize />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.scale-list-items {
  max-height: min(320px, 50vh);
  overflow-y: auto;
  overscroll-behavior: contain;
}

.scale-list-footer {
  flex-shrink: 0;
  border-top: 1px solid var(--canvas-border);
}
</style>
